export { default as KrumagoParentMain } from '../../../views/pages/KrumagoParent/index.jsx';
export { default as AboutMain } from '../../../views/pages/shared/About.jsx';
export { default as KrumagoContact } from '../../../views/pages/shared/KrumagoContact.jsx';
export { default as KrumagoHeader } from '../../../views/pages/shared/KrumagoHeader.jsx';
export { default as KrumagoFooter } from '../../../views/pages/shared/KrumagoFooter.jsx';
